"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".yellow[_ngcontent-%COMP%] {\n  background-color: yellow; }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL01hcHNlbmRlciA0RCBSZWxlYXNlL3dlYnNpdGUvc3JjL2FwcC92Mi9hcHAuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSx5QkFBd0IsRUFDekIiLCJmaWxlIjoic3JjL2FwcC92Mi9hcHAuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIueWVsbG93e1xuICAgIGJhY2tncm91bmQtY29sb3I6IHllbGxvdztcbiAgfVxuICAiXX0= */"];
exports.styles = styles;
